interface IconProps {
  fillColor: string
}

export const MediaPermissionsCheckerArrowIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M47.1927 49.0378C47.632 49.4837 48.3496 49.4891 48.7955 49.0498C49.2414 48.6106 49.2468 47.893 48.8075 47.4471L34.7074 33.1334H42.1214C42.7473 33.1334 43.2547 32.626 43.2547 32C43.2547 31.3741 42.7473 30.8667 42.1214 30.8667H30.8668V42.1212C30.8668 42.7472 31.3742 43.2546 32.0001 43.2546C32.6261 43.2546 33.1335 42.7472 33.1335 42.1212V34.7655L47.1927 49.0378Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72 40C72 57.6731 57.6731 72 40 72C22.3269 72 8 57.6731 8 40C8 22.3269 22.3269 8 40 8C57.6731 8 72 22.3269 72 40ZM69.7333 40C69.7333 56.4213 56.4213 69.7333 40 69.7333C23.5787 69.7333 10.2667 56.4213 10.2667 40C10.2667 23.5787 23.5787 10.2667 40 10.2667C56.4213 10.2667 69.7333 23.5787 69.7333 40Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
